export const convertRegexFromString = (stringPattern: string): RegExp => {
  const regexLiteral = new RegExp(/^\/(.+)\/([a-z]*)$/).exec(stringPattern);

  if (regexLiteral) {
    const [, pattern, flags] = regexLiteral;

    return new RegExp(pattern, flags);
  }

  return new RegExp(stringPattern);
};
